import React from 'react';
import {useSelector} from 'react-redux';
import envConfig from '@ey/voltron-config';
import styled from 'styled-components';
import RemoteComponent from '../ModuleFederation/RemoteComponent';
import {TimeTrackerPlaceholder} from '../ModuleFederation/TimeTrackerPlaceholder';
import Utility from '../../../util/utilityfunctions';
import {labels} from '../../../util/utils';

function TimeTrackerContainer() {
	const engagement = useSelector((state) => state.engagement);
	const userPreferences = useSelector((state) => state.userPreferences);
	return (
		<StyledTracker>
			<RemoteComponent
				id="aion"
				adConfig={envConfig.ad}
				engagementId={Utility.getEngagementIdFromUrl()}
				engagementCodes={engagement.allEngagementCodes}
				workspaceId={engagement.workspaceId}
				engagementDescription={engagement.engagementDescription}
				displayLanguage={userPreferences.displayLanguage}
				darkMode={Utility.getTheme() === 'dark'}
				newBaseFontSize = {true}
				numberFormat={userPreferences.numberFormat}
				loadingFallback={<TimeTrackerPlaceholder placeholderMessage={labels.timeTrackerLoadingFallbackMessage} />}
				errorFallback={<TimeTrackerPlaceholder placeholderMessage={labels.timeTrackerErrorFallBackMessage} />}
			/>
		</StyledTracker>
	);
}

export default TimeTrackerContainer;

const StyledTracker = styled.section`
	//position: absolute;
`;
